// extracted by mini-css-extract-plugin
module.exports = {"InputContainer":"OptionsInput_InputContainer__3Wh64","Label":"OptionsInput_Label__2rJwh","Input":"OptionsInput_Input__3Fu2n"};